import React, { createContext, ReactNode } from 'react';
import { OptionsDTO } from '../../../../../api/useAccountsOptionsQuery';
import { AccountDTO } from '../../../../../api/useAccountsQuery';
import { WorkflowIdEnum } from '../../../../../../../Workflow/api/useWorkflowDataQuery';
import {
  AccountModalUsageContext,
  AccountModalUsageContextOptions,
} from './AccountFormProvider.meta';
import { LocalSaveOptions } from '../AccountForm.meta';

export interface Alert {
  message: string;
  type: 'info' | 'warning' | 'error';
}

interface Context {
  alert: Alert | null;
  setAlert: (alert: Alert | null) => void;
  accountId?: string;
  onClose(): void;
  options: OptionsDTO;
  accounts: AccountDTO[];
  workflowId?: WorkflowIdEnum;
  usageContext?: AccountModalUsageContext;
  usageContextOptions?: AccountModalUsageContextOptions;
  localSaveOptions?: LocalSaveOptions;
}

export const AccountFormContext = createContext<Context | undefined>(undefined);

interface Props {
  value: Context;
  children: ReactNode;
}

export const AccountFormProvider = ({ children, value }: Props) => (
  <AccountFormContext.Provider value={value}>{children}</AccountFormContext.Provider>
);
